export const metaTitle = (title: string): string => `${{ title }} - Hosty`;
